// redux/reducers/categoryReducer.js

  const initialState = {
    loading: false,
    newPass: false,
    error: false,
    categoryListing:[],
    categoryDetail:null
  };
  
  const categoryReducer = (state = initialState, action) => {
    // console.log("category reducers------", state,action);
   switch (action.type) {
     case "ADD_CATEGORY_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_CATEGORY_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_CATEGORY_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };



       case "GET_CATEGORY_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_CATEGORY_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_CATEGORY_REQUEST_SUCCESS":
        return {
          ...state,
          categoryListing: action.payload,
          loading:false,
        };



             case "ADD_KEYWORD_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_KEYWORD_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_KEYWORD_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };


       

        case "GET_KEYWORD_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_KEYWORD_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_KEYWORD_REQUEST_SUCCESS":
        return {
          ...state,
          keywordListing: action.payload,
          loading:false,
        };


      case "GOT_CATEGORY_DETAIL":  
      return {
        ...state,
        categoryDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default categoryReducer;
  